import { cn } from "@repo/lib";

interface ColoredCardProps {
  children: React.ReactNode;
  className?: string;
}

interface ColoredCardInfoHeaderProps {
  children: React.ReactNode;
  className?: string;
}

interface ColoredCardInfoTitleProps {
  children: React.ReactNode;
  className?: string;
}

interface ColoredCardInfoDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

interface ColoredCardInfoButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const ColoredCardInfo = ({
  children,
  className = "",
}: ColoredCardProps): JSX.Element => {
  return (
    <div className={cn("rounded-lg p-4 text-white bg-primary-300", className)}>
      {children}
    </div>
  );
};

export const ColoredCardInfoHeader = ({
  children,
  className = "",
}: ColoredCardInfoHeaderProps): JSX.Element => {
  return <div className={cn("mb-4", className)}>{children}</div>;
};

export const ColoredCardInfoTitle = ({
  children,
  className = "",
}: ColoredCardInfoTitleProps): JSX.Element => {
  return (
    <h2 className={cn("text-2xl font-semibold mb-1 text-neutral-600", className)}>
      {children}
    </h2>
  );
};

export const ColoredCardInfoDescription = ({
  children,
  className = "",
}: ColoredCardInfoDescriptionProps): JSX.Element => {
  return (
    <p className={cn("text-sm text-neutral-600 font-regular", className)}>{children}</p>
  );
};

export const ColoredCardInfoButton = ({
  children,
  onClick,
  className = "",
}: ColoredCardInfoButtonProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        "px-4 py-2 text-sm rounded-full font-semibold transition-colors duration-200 bg-secondary-400 text-white",
        className,
      )}
    >
      {children}
    </button>
  );
};
